import { useEffect, useState } from 'react';
import api from '@/lib/axios';

interface SiteAyarlari {
  fiyat_gosterim_tipi: 'kdv_dahil' | 'kdv_haric';
  kargo_ucreti: string;
  ucretsiz_kargo_limiti: string;
  [key: string]: string;
}

let cache: SiteAyarlari | null = null;
let promise: Promise<SiteAyarlari> | null = null;

export function useSiteAyarlari() {
  const [ayarlar, setAyarlar] = useState<SiteAyarlari | null>(cache);

  useEffect(() => {
    if (cache) { setAyarlar(cache); return; }
    if (!promise) {
      promise = api.get('/site-ayarlari').then(res => {
        cache = res.data;
        return cache!;
      });
    }
    promise.then(data => setAyarlar(data));
  }, []);

  return ayarlar;
}
